import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UIIcon } from '../icon';

@Component({
  selector: 'ui-back-button',
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
  standalone: true,
  imports: [UIIcon],
})
export class UIBackButton {
  @Input() backToUrl?: string;
  @Input() relativeTo?: boolean = true;
  @Input() fallbackUrl = '/';
  @Input() iconSize = '20px';

  constructor(
    private location: Location,
    private router: Router,
    private aRoute: ActivatedRoute
  ) {}

  onGoBack(): void {
    if (this.backToUrl) {
      if (this.relativeTo) {
        // Navigate relative to the current route
        this.router.navigate([this.backToUrl], {
          relativeTo: this.aRoute,
        });
      } else {
        // Navigate using absolute URL
        this.router.navigateByUrl(this.backToUrl);
      }
    } else if (window.history.length > 1) {
      this.location.back(); // Go to the previous page
    } else {
      this.router.navigateByUrl(this.fallbackUrl); // Navigate to the fallback URL
    }
  }
}
